import { Component } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { InputFieldComponent } from '../input-field/input-field.component';
import { DateInputFieldComponent } from '../date-input-field/date-input-field.component';
import { SelectInputFieldComponent } from '../select-input-field/select-input-field.component';
import { AddButtonComponent } from '../add-button/add-button.component';

@Component({
  selector: 'ui-showcase',
  standalone: true,
  imports: [InputFieldComponent, DateInputFieldComponent, SelectInputFieldComponent, AddButtonComponent],
  templateUrl: './ui-showcase.component.html',
  styleUrls: ['./ui-showcase.component.scss'],
})
export class UiShowcaseComponent {
  textControl = new FormControl('');
  textWithErrorControl = new FormControl('', Validators.required);
  numberControl = new FormControl('');
  dateControl = new FormControl('');
  selectControl = new FormControl('');

  selectOptions = [
    { id: '1', displayValue: 'Option 1' },
    { id: '2', displayValue: 'Option 2' },
    { id: '3', displayValue: 'Option 3' },
  ];

  constructor() {
    this.textWithErrorControl.markAsTouched();
  }

  onAddButtonClick(): void {}
}
